import { FeatureName, useAssetListFilter, useIsFeatureEnabled, useSetAssetListFilter } from '@gripp/shared-logic';
import { AssetSearchInput, countFilters, FilterHeaders, SlideAction, useSlideLayout, ViewMode } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useLocation, useNavigate, useParams } from 'react-router';
import { AddButton } from '../../shared/components/addButton/addButton';
import { ModalButton } from '../../shared/components/modalButton';
import { AssetsFiltersOld } from './assetsFilters-old';
import { NewAssetModal } from './newAssetModal';

export const AssetsFilters = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);
  if (!isCropCircleEnabled) {
    return <AssetsFiltersOld />;
  }
  return <AssetsFiltersBase />;
};

export const AssetsFiltersBase = () => {
  const navigate = useNavigate();
  const { assetId } = useParams();
  const location = useLocation();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const { data: assetFilter } = useAssetListFilter();
  const { mutateAsync: setAssetListFilter } = useSetAssetListFilter();
  const filterCount = countFilters(assetFilter);

  const onNavigate = async () => {
    if (location.pathname.includes(`/assets/${assetId}/detail`)) {
      navigate(`/assets/${assetId}/detail/filters`);
      return;
    }

    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }

    navigate(`/assets/filters`);
  }

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders 
        currentSearchKeyword={assetFilter?.keyword}
        searchComponent={<AssetSearchInput />}
        onFilterPress={onNavigate}
        onSearchClose={() => setAssetListFilter({ keyword: '' })}
        filterCount={filterCount}
        Routes={{}}
      />

      <ModalButton
        label=""
        customButton={(toggleVisibility) => (
          <AddButton onPress={() => toggleVisibility(true)} />
        )}
        modalComponent={({ onComplete }) => (
          <NewAssetModal closeModal={onComplete} />
        )}
        containerStyle={styles.modal}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
  },
  searchButton: { padding: 8, borderRadius: 8 },
  filterButton: { padding: 8, borderRadius: 8 },
  filterButtonContent: { position: 'relative' },
  badgeContainer: { position: 'absolute', top: -6, right: -6 },
  modal: {
    alignSelf: 'center',
    backgroundColor: 'white',
    padding: 0,
    margin: 0,
    borderRadius: 10,
    width: 560,
    minHeight: 400,
  },
});
